import {TableauContentActions, TableauContentActionsTypes} from './actions';
import {ACTION_TYPES} from '../constants';
import {updateDotNotationObject} from '../../utils';

export const initialTableauContentState: TableauContentState = {
  init: false,
  form: {
    action: ACTION_TYPES.WORKBOOK_PDF,
    custom_view_id: '',
    custom_view_name: '',
    filters: '',
    integration_id: '',
    orientation: '',
    page_type: '',
    viz_height: '',
    viz_width: '',
    resolution: '',
    view_id: '',
    view_name: '',
    workbook_id: '',
    workbook_name: '',
  },
}

export interface TableauContentState {
  init: boolean;
  form: any;
}

export default function tableauContentReducer(
  state: TableauContentState = initialTableauContentState,
  action: TableauContentActions
): TableauContentState {

  switch (action.type) {
    case TableauContentActionsTypes.SET_INIT:
      return {
        ...state,
        init: action.payload,
      }
    case TableauContentActionsTypes.SET_TABLEAU_CONTENT_FORM:
      return {
        ...state,
        form: action.payload,
        init: true,
      }
    case TableauContentActionsTypes.SET_TABLEAU_CONTENT_FORM_KEY_VALUE:
      if (action.payload.key.includes('.')) {
        return {
          ...state,
          form: updateDotNotationObject(
            JSON.parse(JSON.stringify(state.form || {})),
            action.payload.key,
            action.payload.value
          )
        }
      }

      return {
        ...state,
        form: {
          ...state.form || {},
          [action.payload.key]: action.payload.value,
        },
      }
    case TableauContentActionsTypes.SET_TABLEAU_CONTENT_FORM_KEYS_VALUES:
      return {
        ...state,
        form: {
          ...state.form || {},
          ...action.payload,
        }
      }
    default:
      return state;
  }
};
